import React from "react";
import ReactDOM from "react-dom";
import queryString from "query-string";
import AdvancedSearch from "./advanced-search/AdvancedSearch";
import "./jquery.easyPaginate";

/**
 * ObjectFitImages for Polyfill images
 */
import objectFitImages from "object-fit-images";

/**
 * Magnific Popup for modals
 */
import "magnific-popup";
import { parseCarouselClassLists, setCarouselProps } from "./carouselSetup";

/**
 * Related Products Table functionality
 */
import { relatedProductsTable } from "./relatedProductsTable";

/**
 * Product Documentation Search functionality
 */
import { navigation } from "./navigation";
import { navSearch } from "./search";
import { documentSearch } from "./documentation-search";

/**
 * Load More Posts button functionality
 */
import { loadMorePostsSetup } from "./loadMorePosts";

/**
 * Lazysizes for images
 */
import "lazysizes";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import "./select2.full.min.js";
import { autoSizer } from "lazysizes";

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.rias = window.lazySizesConfig.rias || {};

// configure available widths to replace with the {width} placeholder
window.lazySizesConfig.rias.widths = [320, 480, 640, 720, 960, 1024, 2048];
window.lazySizesConfig.rias.absUrl = true;

const DEBUG = process.env.NODE_ENV === "development";

console.log("Environment: ", process.env.NODE_ENV);

if (DEBUG) {
  console.log("Loaded main.js");
}

jQuery(function ($) {
  $(document).ready(function () {
    objectFitImages();
    relatedProductsTable($);
    navigation($);
    documentSearch($);
    loadMorePostsSetup();
    navSearch($);

    $(".js-open-popup").magnificPopup({
      type: "inline",
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    //in page navigation
    $(".js-in-page-nav-toggle").click(function () {
      $(".js-in-page-nav-arrow").toggleClass("fa-angle-up");
      $(this).next("nav").slideToggle();
    });
  });
  jQuery(function ($) {
    $(document).load(function () {
      navSearch($);
    });
  });
  //find all the carousels on the page
  if (document.querySelectorAll("[ class*=js-carousel ]").length > 0) {
    let carouselArray = parseCarouselClassLists(
      document.querySelectorAll("[ class*=js-carousel ]")
    );
    setCarouselProps(carouselArray);
  }

  // Advanced search menu ui
  const advancedSearchEl = document.querySelector("#advanced-search");
  if (advancedSearchEl) {
    const parsedSearch = queryString.parse(window.location.search);

    ReactDOM.render(
      <AdvancedSearch
        search={parsedSearch.search}
        ref={(ref) => {
          window.advancedSearch = ref;
        }}
      />,
      advancedSearchEl
    );
  }

  $("#toggle-advanced-search").on("click", () => {});

  $("#doc-form-wrapper select#all-products").select2({
    placeholder: "Choose a Product",
    multiple: true,
    allowClear: true,
    width: "auto",
    containerCssClass: "flex-1 px-3",
  });
  $("#doc-form-wrapper select#document-type").select2({
    placeholder: "Choose a Document Type",
    multiple: true,
    allowClear: true,
    width: "auto",
    containerCssClass: "flex-1 px-3",
  });

  $("ul.list.paginate-list").each(function () {
    var currentPage = 0;
    var numPerPage = 10;
    var $table = $(this);
    $table.bind("repaginate", function () {
      $table
        .find(".doc-item")
        .hide()
        .slice(currentPage * numPerPage, (currentPage + 1) * numPerPage)
        .show();
    });
    $table.trigger("repaginate");
    var numRows = $table.find(".doc-item").length;
    var numPages = Math.ceil(numRows / numPerPage);
    var $pager = $('<ul class="pagination pagination-md"></ul>');
    for (var page = 0; page < numPages; page++) {
      var pagenum = page + 1;
      $('<li class="page-item"></li>')
        .html(
          '<a href="#" class="inactive ajax-pagination">' + pagenum + "</a>"
        )
        .bind(
          "click",
          {
            newPage: page,
          },
          function (event) {
            currentPage = event.data["newPage"];
            $table.trigger("repaginate");
            $(this).addClass("active").siblings().removeClass("active");
          }
        )
        .appendTo($pager)
        .addClass("clickable");
    }
    $pager.insertAfter($table).find("li.page-item:first").addClass("active");
  });
  $(".smart-module-docs").on("click", "a.ajax-pagination", function (e) {
    $("html, body").animate(
      {
        scrollTop: $(".smart-module-docs").offset().top,
      },
      500
    );
    return false;
  });

  $("#white_papers").easyPaginate({
    paginateElement: ".white_paper",
    elementsPerPage: 10,
    firstButton: true,
    lastButton: true,
    prevButton: true,
    nextButton: true,
    firstButtonText: "First",
    lastButtonText: "Last",
    prevButtonText: "Prev",
    nextButtonText: "Next",
  });
});

//scroll window to top of tab on mobile on single product pages
if (document.querySelector(".single-product-tabs")) {
  let windowWidth = window.innerWidth;
  let allTabs = Array.from(document.querySelectorAll(".js-product-tab-label"));
  let listenersApplied = false;

  let scrollToTab = (event) => {
    if (event) {
      //get event target index within allTabs array
      const target = (element) => element === event.target;
      let index = allTabs.findIndex(target);

      //tab heights are uniform, used for calculation below
      let tabHeight = allTabs[0].offsetHeight;

      //calculate Y value to scroll window to
      let scrollPoint = allTabs[0].offsetTop + index * tabHeight;
      window.scrollTo(0, scrollPoint);
    }
  };

  //toggle tabs display
  let toggleTabs = (e) => {
    if (e) {
      if (jQuery(".tab-label" + e.data.step).css("font-weight") == "700") {
        jQuery(".tab-detail" + e.data.step).toggle();
      }

      if (jQuery(".tab-detail" + e.data.step).is(":hidden")) {
        jQuery(".arrow-tab" + e.data.step).html("&#x25BC;");
      } else {
        jQuery(".arrow-tab" + e.data.step).html("&#x25B2;");
      }
    }
  };

  if (windowWidth < 1024) {
    listenersApplied = true;

    for (let tab of allTabs.entries()) {
      tab[1].addEventListener("click", scrollToTab);
    }

    for (let step = 1; step <= 5; step++) {
      jQuery(".tab-label" + step).on("click", { step: step }, toggleTabs);
    }
  }

  window.addEventListener("resize", function () {
    windowWidth = window.innerWidth;

    if (windowWidth < 1024 && listenersApplied === false) {
      listenersApplied = true;

      for (let tab of allTabs.entries()) {
        tab[1].addEventListener("click", scrollToTab);
      }

      for (let step = 1; step <= 5; step++) {
        jQuery(".tab-label" + step).on("click", { step: step }, toggleTabs);
      }
    } else if (windowWidth >= 1024 && listenersApplied === true) {
      listenersApplied = false;

      for (let tab of allTabs.entries()) {
        tab[1].removeEventListener("click", scrollToTab);
      }

      for (let step = 1; step <= 5; step++) {
        jQuery(".tab-label" + step).unbind("click");
      }
    }
  });
}

//Nav Search Form Show/Hide
jQuery(function ($) {
  $(document).ready(function () {
    $('body :not(script)').contents().filter(function() {
      return this.nodeType === 3;
    }).replaceWith(function() {
      return this.nodeValue.replace(/[®©]/g, '<sup>$&</sup>');
    });
    $(".js-show-nav-search").on("click", function (e) {
      e.preventDefault();
      let searchForm = document.querySelector(".js-nav-search-form");

      if (this.nextElementSibling === searchForm) {
        searchForm.classList.toggle("invisible");
        searchForm.classList.toggle("opacity-0");
      }
    });
  });
});
